module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero",
    style: ({
      'background-image': 'url(' + _vm.bgImagePath + ')'
    })
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('h1', {
    staticClass: "hero__title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "hero__text"
  }, [_vm._v(_vm._s(_vm.text))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34c3b8c7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hero.vue
// module id = 173
// module chunks = 0